import { Component, Mixins } from 'vue-property-decorator';
import OrderGridsExcelDown from '@/components/common/order/mixins/OrderGridsExcelDown'

@Component
export default class OrderListGrids extends Mixins(OrderGridsExcelDown) {

  public gridProps: any = {
    options: {
      header: {
        height: 33,
        bacground: '#ccc'
      },
      columnOptions: {
        minWidth: 50,
        resizable: true,
      },
      
      displayRowCount: 30,
      isInitialRequest: true,
      // keyColumnName: 'orderProductOptionNo',
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0,
        centerAlign: true
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    // keyColumnName: 'orderProductOptionNo',
    columnOptions: {
      useFormattedValue: true
    },
    showDummyRows: true,
    columns: []
  };

  public listColumns: any = [
    '플랫폼구분',
    '쇼핑몰구분',
    '주문구분',
    '예약주문',
    '회원그룹',
    '결제수단',
    '주문번호',
    '주문자명',
    '주문자 연락처',

    '회원번호',
    '업무메시지',
    '파트너사',
    'HS CODE',
    '상품번호',
    '상품관리코드',

    '상품 이미지',
    '상품명',
    '영문상품명',
    '옵션관리코드',
    '옵션명',
    '수량',
    '판매가(할인적용가)',
    '주문일시',
    '구분',
    '실패사유',
    '주문상품옵션번호',
    '정기결제(배송) 신청 번호',
  ];
}
